import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist py-6 sm:py-9" data-id="element-33" data-mp="1hd1nhy7fx7zi">
      <div className="mx-auto max-w-[860px] px-4 sm:px-6" data-id="element-34" data-mp="1hdum2bw8wr6k">
        <h2 className="text-center text-[23px] leading-none text-navy sm:text-[38px]" data-id="element-35" data-mp="1cf9ka81chzg0">
          Frequently asked <span className="text-diag" data-id="element-36" data-mp="2a2idyqbi2et3">questions</span>
        </h2>

        <div className="mt-4 divide-y divide-line overflow-hidden rounded-md border border-line bg-white" data-id="element-37" data-mp="2535py28w71ox">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <div key={faq.question} data-id="element-38" data-mp="1v4g4y0lp914g" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition-colors duration-150 ease-out hover:bg-mist" data-id="element-39" data-mp="oow2rbgdzizo">
                  <span className="font-display text-[14.5px] font-semibold uppercase leading-tight text-navy sm:text-[17px]" data-id="element-40" data-mp="1pkqp5u1qcmu2">
                    {faq.question}
                  </span>
                  <Icon className="h-4 w-4 shrink-0 text-diag" strokeWidth={3} aria-hidden="true" data-id="element-41" data-mp="1fn2kabaetyy6" />
                </button>
                {isOpen && <p id={`faq-${i}`} className="px-4 pb-3 text-[13.5px] font-medium leading-snug text-steel sm:text-[15px]" data-id="element-42" data-mp="16oh42mseuw0k">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}